module.exports = __webpack_public_path__ + "img/chrome8.96803d9a.png";